import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "placeholder", "output", "errorOutput", "disclaimer", "quota", "feedback", "feedbackToken"]
  static values = { url: String, autostart: Boolean, done: Boolean }

  connect() {
    this.buffer = ""

    // Turbo restores the box from its cache with the finished summary (back
    // button) and shows the cached page as a preview before a visit. Neither
    // starts the stream again, which would request and count the summary again.
    if (this.doneValue || document.documentElement.hasAttribute("data-turbo-preview")) return

    if (this.autostartValue) {
      this.generate()
    }
  }

  generate() {
    this.buttonTarget.hidden = true
    this.placeholderTarget.hidden = false

    if (this.hasQuotaTarget) {
      this.quotaTarget.hidden = true
    }

    const url = new URL(this.urlValue, window.location.origin)

    this.source = new EventSource(url.toString())

    this.source.onmessage = (event) => {
      this.placeholderTarget.hidden = true
      this.disclaimerTarget.hidden = false
      this.buffer += event.data.replace(/\\n/g, "\n")
      this.outputTarget.innerHTML = this.buffer
    }

    this.source.addEventListener("done", (event) => {
      this.source.close()
      // Kept as an attribute in the cached page of Turbo (see connect)
      this.doneValue = true
      this.showFeedback(event.data)
    })

    this.source.addEventListener("error", (event) => {
      // Native connection-error events carry no data; only handle server-sent errors here.
      if (!event.data) return
      // If we don't have an error output target, just close the connection and do nothing.
      if (!this.hasErrorOutputTarget) {
        this.source.close()
        return
      }

      this.placeholderTarget.hidden = true
      this.disclaimerTarget.hidden = true
      this.outputTarget.innerHTML = ""
      this.outputTarget.hidden = true
      this.errorOutputTarget.hidden = false
      this.errorOutputTarget.innerHTML = event.data.replace(/\\n/g, "\n")

      this.source.close()
    })

    this.source.onerror = () => {
      this.source.close()
    }
  }

  // The done event carries the token to rate the stored summary (see
  // ai_summary_feedback_controller.js). Without a token there is nothing to rate.
  showFeedback(data) {
    if (!data || !this.hasFeedbackTarget || !this.hasFeedbackTokenTarget) return

    const { feedback_token: token } = JSON.parse(data)
    if (!token) return

    this.feedbackTokenTarget.value = token
    this.feedbackTarget.hidden = false
  }

  disconnect() {
    if (this.source) {
      this.source.close()
    }
  }
}
